module.exports = __webpack_public_path__ + "img/LighteningCategoryScreenshot-1250h.3d41289f.webp";